module.exports = __webpack_public_path__ + "01ea978f/img/pdf-icon.79f04a36.svg";